export function setParamsContacts(state, filter) {
    state.params_contacts.filter = filter;
}
export function setLines(state, lines) {
    state.lines = lines;
}
export function setBrands(state, brands) {
    state.brands = brands;
}
export function setDiscount(state, discount) {
    state.discount = discount;
    state.params = {
        id: discount.id,
        contact_id: discount.contact_id,
        brand_id: discount.brand_id,
        discount_percentage: discount.discount_percentage,
        line_id: discount.line_id
    };
}
export function setDiscounts(state, discounts) {
    console.log('discounts',discounts)
    state.discounts = discounts;
}
export function setContacts(state, data) {
    state.contacts = data;
}

export function resetFields(state) {
    state.params = {
        client: null,
        line: null,
        brand: null,
        percentage: null
    };
}

export function setloading(state, value) {
    state.loading.module = value;
}
export function setFile(state, value) {
    state.file = value;
    console.log('mutation')
}

export function setPerPage(state, perPage) {
    state.params.page = 1;
    state.params.perPage = perPage;
}

export function setPage(state, page) {
    state.params.page = page;
}

export function setUploadFileButton(state) {
    state.upload_file = !state.upload_file;
}



// WEBPACK FOOTER //
// ./src/modules/customerDiscountBrand/mutations.js